import {tuiIconsPathFactory} from '@taiga-ui/core/utils';

const MAPPER: Record<string, string> = {
  user: 'user',
  menu: 'menu',
  arrowRightBig: 'arrow-right-big',
  angleDown: 'angle-down',
  angleUp: 'angle-up',
  offer: 'offer',
  arrowRight: 'arrow-right',
  padlock: 'padlock',
  play: 'play',
  facebook: 'fb',
  instagram: 'instagram',
  youtube: 'youtube',
  twitter: 'twitter',
  tiktok: 'tiktok',
  x: 'x',
  heroPlay: 'hero-play',
  cookie: 'cookie',
  share: 'share',
  whatsapp: 'whatsapp',
  check: 'check',
  copyAlt: 'copy-alt',
};

export function iconsPath(name: string): string {
  if (name.includes('/')) {
    // If path is passed in as a name don't change anything
    return name;
  }

  return MAPPER[name]
    ? `assets/icons/${MAPPER[name]}.svg#${MAPPER[name]}`
    : tuiIconsPathFactory('assets/taiga-ui/icons/')(name);
}
